import {
  VuexModule, Module, Action,
} from 'vuex-module-decorators';
import Vue from 'vue';
import {
  BASE_URL,
  AUTO_API_URL,
  M_POST,
  FETCH_CASHBACK,
  FETCH_DETAIL_CASHBACK,
  GET_CASHBACK,
} from '@/utils/api';

@Module({ name: 'CashBack' })
export default class CashBack extends VuexModule {
  @Action
  getCashback(token: string) {
    return Vue.axios({
      url: BASE_URL + GET_CASHBACK,
      method: M_POST,
      data: token,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code !== 0) {
          throw data.status;
        } else {
          return data;
        }
      })
      .catch((err: string) => err);
  }

  @Action
  getDetailCashback(token: string) {
    return Vue.axios({
      url: BASE_URL + FETCH_DETAIL_CASHBACK,
      method: M_POST,
      data: token,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code !== 0) {
          throw data.status;
        } else {
          return data;
        }
      })
      .catch((err: string) => err);
  }

  @Action
  fecthCashback(token: string) {
    return Vue.axios({
      url: AUTO_API_URL + FETCH_CASHBACK,
      method: M_POST,
      data: token,
    })
      .then(({ data }) => data)
      .catch((err: string) => err);
  }
}
